import { defineTable, Schema } from 'squid';
export const inspectionsTable = defineTable('inspections', {
    entity_id: Schema.String,
    inspection_id: Schema.String,
    date_completed: Schema.nullable(Schema.String),
    date_canceled: Schema.nullable(Schema.String),
    inspector_role: Schema.nullable(Schema.String),
    notes: Schema.nullable(Schema.String),
    scheduled_date: Schema.nullable(Schema.String),
    status: Schema.String,
    confirmed: Schema.nullable(Schema.Boolean),
    confirmed_by: Schema.nullable(Schema.String),
    confirmed_on: Schema.nullable(Schema.String),
});
